import { useApp } from '@/hooks/useApp'
import { useGetGrouppedAvailablePackages, useUpdateOfferPackage } from '@/hooks/useOfferPackage'
import { Box, Button, Heading, HStack, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { type OfferPackage, type OfferProperty } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useState } from 'react'

const GetGroups = (product: Product): { [groupId: string]: string } => {
  switch (product) {
    case Product.PropertyInsurance:
      return {
        '0': 'Odpovědnost',
        '1': 'Stavba',
        '2': 'Domácnost'
      }
    // ostatni maji jen jednu kategorii, takze textace neresim
    case Product.LiabilityInsurance:
    case Product.TravelInsurance:
    default:
      return {
        '0': '',
      }
  }
}

const GetGroupSelectedValues = (offer: OfferPackage): { [groupId: string]: string } => {
  return {
    '0': offer.liabilityPackageId?.toString() ?? '',
    '1': offer.realtyPackageId?.toString() ?? '',
    '2': offer.householdPackageId?.toString() ?? ''
  }
}

export const OfferPackageSettingsFormPackages = ({
  offer,
  isReadOnly,
  submitCallback
}: {
  offer: OfferPackage | OfferProperty,
  isReadOnly: boolean,
  submitCallback?: () => void
}) => {
  const { product, app } = useApp()
  const groups = GetGroups(product!)
  const origValues = GetGroupSelectedValues(offer)
  const [selectedValues, setSelectedValues] = useState(origValues)

  const groupedAvailablePackages = useGetGrouppedAvailablePackages(offer.offerId)
  const { mutateAsync: updatePackage } = useUpdateOfferPackage()

  const [isLoading, setIsLoading] = useState(false)

  const submitForm = async () => {
    setIsLoading(true)

    const packages = Object.entries(selectedValues)
      .map(([groupKey, packageId]) => {
        return {
          groupId: parseInt(groupKey),
          packageId: parseInt(packageId)
        }
      })
      .filter(item => item.packageId > 0 && origValues[item.groupId] !== item.packageId.toString())

    await updatePackage({ offerId: offer.offerId, packages: packages })

    setIsLoading(false)

    submitCallback?.()
  }

  const changed = Object.keys({ ...origValues, ...selectedValues }).some(
    groupId => origValues[groupId] !== selectedValues[groupId]
  )

  return (
    <>
      <Stack>
        {Object.entries(groupedAvailablePackages).reverse().map(([groupKey, items]) => (
          <Box key={groupKey} mb={8}>
            <Heading size="md" mb={4}>{groups[groupKey]}</Heading>

            <RadioGroup
              value={selectedValues[groupKey] || ''}
              onChange={(val) => setSelectedValues(prev => ({ ...prev, [groupKey]: val }))}
            >
              <HStack spacing={2} gap={6}>
                {items.map(item => (
                  <Radio key={item.id} value={item.id.toString()} isDisabled={isReadOnly}>
                    {item.name}
                  </Radio>
                ))}
              </HStack>
            </RadioGroup>
          </Box>
        ))}

        {!isReadOnly &&
          <Button
            ml='auto'
            isDisabled={isLoading || !changed}
            isLoading={isLoading}
            colorScheme="green"
            onClick={submitForm}>
            Uložit
          </Button>
        }
      </Stack>
    </>
  )
}